import { Enrollment, Field, FieldGeometry } from "@/types/field";
import { UseQueryResult } from "@tanstack/react-query";
import { createContext, Dispatch, SetStateAction } from "react";
import { CropCycle, CropCycleV2 } from "@/types/cropCycle";
import { Imagery, ImageryType } from "@/types/imagery";
import { Coordinates } from "../utils/map";
import { NaveWaterEstimate } from "@/types/water";

type FieldDashboardContextType = {
    fieldId?: string;
    cropCycleQuery: UseQueryResult<CropCycle[], Error>;
    cropCycleQueryV2: UseQueryResult<CropCycleV2[], Error>;
    fieldImageryQuery: UseQueryResult<Imagery[], Error>;
    selectedCropCycle: CropCycle | CropCycleV2 | null;
    geometryQuery: UseQueryResult<FieldGeometry, Error>;
    fieldQuery: UseQueryResult<Field, Error>;
    setSelectedCropCycle: Dispatch<
        SetStateAction<CropCycle | CropCycleV2 | null>
    >;
    filteredImagery: Imagery[];
    selectedImage?: Imagery;
    setSelectedImage: Dispatch<SetStateAction<Imagery | undefined>>;
    imageryBbox?: Coordinates | undefined;
    fieldIsAdvanced: boolean;
    fieldIsStandard: boolean;
    fieldIsComplete: boolean;
    imageType: ImageryType;
    setImageType: Dispatch<SetStateAction<ImageryType>>;
    fieldBbox?: Coordinates | undefined;
    fieldEnrollmentQuery: UseQueryResult<Enrollment[], Error>;
    imageryOptions: { key: ImageryType; label: string }[];
    fieldHasIrrigation: boolean;
    fieldWaterQuery: UseQueryResult<NaveWaterEstimate[], Error>;
    selectedDate: string | undefined;
    setSelectedDate: Dispatch<SetStateAction<string | undefined>>;
};

const FieldDashboardContext = createContext<FieldDashboardContextType | null>(
    null,
);

export default FieldDashboardContext;
export type { FieldDashboardContextType };
